import { ConditionalPartial } from '../../../../utils';

import { CreateRegulatoryDetailsRequestDto } from './create-regulatory-details.request.dto';

export class UpdateRegulatoryDetailsRequestDto extends ConditionalPartial(CreateRegulatoryDetailsRequestDto) { }
